function cov_1t7bagvb7d() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Door.tsx";
  var hash = "537ed056f805b5f46aa277309b62f55d1ae8d94d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Door.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "537ed056f805b5f46aa277309b62f55d1ae8d94d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1t7bagvb7d = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1t7bagvb7d();
var Icon = (cov_1t7bagvb7d().s[0]++, {
  name: 'door',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.5 4.5V19.5H16.5V4.5H7.5ZM6 2C5.44772 2 5 2.44772 5 3V21C5 21.5523 5.44772 22 6 22H18C18.5523 22 19 21.5523 19 21V3C19 2.44772 18.5523 2 18 2H6Z\" fill=\"currentColor\"/>\n  <path d=\"M15.5 12.25C15.5 12.9404 14.9404 13.5 14.25 13.5C13.5596 13.5 13 12.9404 13 12.25C13 11.5596 13.5596 11 14.25 11C14.9404 11 15.5 11.5596 15.5 12.25Z\" fill=\"currentColor\"/>"
});
export default Icon;